const Select = ({ countries, value, onChange }) => (
  <div className="mb-6">
    <select
      value={value}
      onChange={onChange}
      name="country"
      className="form-select form-select-lg
                appearance-none
                px-4
                py-5
                text-md
                font-normal
                 bg-clip-padding bg-no-repeat
                ease-in-out
                m-0
                focus:text-gray-700 focus:bg-white  focus:outline-none
                bg-gray-50 border border-slate-400 shadow-lg  shadow-slate-300/50 active:shadow-lg focus:shadow-sm text-gray-900 text-sm rounded-lg hover:border-blue-500 hover:border-2 focus:ring-blue-500 focus:border-blue-500 block w-full   transition-all duration-300
                "
    >
      <option value="">Country</option>
      {countries.map((country) => (
        <option
          key={
            country.name === "Palestine, State of" ? "Palestine" : country.name
          }
          value={country.alpha2Code}
        >
          {country.name === "Palestine, State of" ? "Palestine" : country.name}
        </option>
      ))}
    </select>
  </div>
);

export default Select;
